export default __webpack_public_path__ + "static/media/12.35fa4d37.png";